import React, { useEffect, useRef, useState } from 'react';
import * as S from './style';
import bgImg from 'images/BG.png';
import { Route, Switch } from 'react-router-dom';
import { isMobile } from 'components/globals';
import { useSizeDetect } from 'helpers/hooks';
import * as Constant from 'constant';
import { useHistory } from 'react-router';
import { updateUserDetails } from 'Services/Api';
import FirstScreen from './FirstScreen';
import SecondScreen from './SecondScreen';
import CreatingScreen from './CreatingScreen';
import mixpanel from 'mixpanel-browser';
import { getLanguageFromQueryParams } from 'languages';

function SignUp(props) {
  const isMobileMode = isMobile();
  const signUpContainerRef = useRef(null);
  const history = useHistory();
  const [containerWidth, setContainerWidth] = useState(0);
  const [registrationId, setRegistrationId] = useState('');
  const [referralSignupId, setReferralSignupId] = useState('');
  const [showFinishScreen, setShowFinishScreen] = useState(false);
  const { resizeWidth } = useSizeDetect(signUpContainerRef.current);
  const isTabletBreakpoint = containerWidth < Constant.DEVICE_MAX_SIZE.medium;

  useEffect(() => {
    handleParams();

    mixpanel.track('Page view', {
      'Page name': 'Signup',
      'Page URL': window.location.href,
      'Page referrer': document.referrer,
    });
  }, []);

  useEffect(() => {
    setContainerWidth(resizeWidth);
  }, [resizeWidth]);

  const handleParams = () => {
    const searchParams = new URL(window.location).searchParams;
    const regId = searchParams.get('rid');
    if (!registrationId && regId) {
      setRegistrationId(regId);
    } else if (!registrationId && !regId) {
      const searchParams = window.location.search;
      history.replace(`${Constant.ROUTE_AUTH_URL.signup.step1}${searchParams}`);
    }

    const rsid = searchParams.get('rsid');
    if (rsid) {
      setReferralSignupId(rsid);
    }
  };

  const updateRegistration = async (data) => {
    const response = await updateUserDetails(data, registrationId);
    return response.success;
  };

  const handleFirstScreenSuccess = (registrationId) => {
    setRegistrationId(registrationId);
    history.push(`${Constant.ROUTE_AUTH_URL.signup.step2}?rid=${registrationId}&language=${getLanguageFromQueryParams()}`);
  };

  const handleSecondScreenSubmit = async (companySize, businessType, businessTypeLabel, companyName, companySizeLabel) => {
    if (
      await updateRegistration({
        businessType,
        companySize,
        companyName: companyName.trim(),
      })
    ) {
      mixpanel.track(
        'Signup success',
        {
          'Industry selection': businessTypeLabel,
          'Company size': companySizeLabel,
          'Previous page': document.referrer,
        },
        { send_immediately: true },
        () => {
          history.push(Constant.ROUTE_AUTH_URL.signup.finish);
          setShowFinishScreen(true);
        }
      );
    }
  };

  const getTimeZoneCode = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const handleCreateUser = () => {
    const timezone = getTimeZoneCode();

    const params = new URLSearchParams({
      regid: registrationId,
      fb: true,
      timezone,
    });

    if (referralSignupId) {
      params.append('rsid', referralSignupId);
    }

    window.location = `/web/CreateOrganization.aspx?${params.toString()}`;
  };

  return (
    <S.SignUpBackground ref={signUpContainerRef} bgImg={bgImg}>
      {showFinishScreen ? (
        <Switch>
          <Route path={Constant.ROUTE_AUTH_URL.signup.finish}>
            <CreatingScreen onCreateUser={handleCreateUser} isTabletBreakpoint={isTabletBreakpoint} />
          </Route>
        </Switch>
      ) : (
        <Switch>
          <Route path={Constant.ROUTE_AUTH_URL.signup.step2}>
            <SecondScreen
              isMobileMode={isMobileMode}
              containerWidth={containerWidth}
              onSubmit={handleSecondScreenSubmit}
              isRtl={props.isRtl}
              isTabletBreakpoint={isTabletBreakpoint}
            />
          </Route>
          <Route>
            <FirstScreen
              isRtl={props.isRtl}
              containerWidth={containerWidth}
              isMobileMode={isMobileMode}
              onSuccess={handleFirstScreenSuccess}
              isTabletBreakpoint={isTabletBreakpoint}
            />
          </Route>
        </Switch>
      )}
    </S.SignUpBackground>
  );
}

export default SignUp;
